import { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import {
  adminActions,
  adminBroadcastNotification,
  IAdminSendBroadcastApiParams,
  resetStatus,
  successSelector,
  updateBroadcastNotification,
} from '@pharmaplan/common';

import { showSuccess } from '../../../components/Admin/Profile/Pharmacist/PharmacistViewProfile/helper';
import strings from '../../../localization';
import { useAppDispatch } from '../../useAppDispatch';
import { useAppSelector } from '../../useAppSelector';

const { updateBroadcastNotification: successAction } = adminActions;

// SAVES CHANGES TO THE SCHEDULED NOTIFICATION BEING EDITED, THEN RETURNS TO THE LIST
const useBroadcastNotificationUpdate = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { broadcastMessageId } = useAppSelector(adminBroadcastNotification);
  const isUpdated = useAppSelector((state) =>
    successSelector([successAction], state));

  const updateNotification = (params: IAdminSendBroadcastApiParams) => {
    dispatch(updateBroadcastNotification({ ...params, broadcastMessageId }));
  };

  useEffect(() => {
    if (isUpdated) {
      showSuccess(dispatch, strings.updatedSuccessfullyFormat);
      dispatch(resetStatus([successAction]));
      navigate(-1);
    }
  }, [dispatch, isUpdated, navigate]);

  return { updateNotification };
};

export default useBroadcastNotificationUpdate;
